import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';
const middlewares = [thunk];
// if (
//   process.env.REACT_APP_CONFIG_ENV === 'dev' ||
//   process.env.REACT_APP_CONFIG_ENV === 'local' ||
//   !process.env.REACT_APP_CONFIG_ENV
// )
//   middlewares.push(require('redux-immutable-state-invariant').default());
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)));

export default store;
